import {pluralize} from "@pg-mono/string-utils";

export const offerPlural = pluralize(["ofertę", "oferty", "ofert"]);
import {pluralize} from "@pg-mono/string-utils";

export const offerPlural = pluralize(["ofertę", "oferty", "ofert"]);
